import {CardContent} from "@mui/material";
import {RadioGroup} from "@variocube/app-ui";
import React, {useEffect} from "react";
import {useUser, useUserCreditCards} from "../../../../../context/auth";
import {maskCreditCardNumber} from "../../../../../utils/maskCreditCardNumber";
import {StepProps} from "./step-props";
import {WizardStepCard} from "./wizard-step-card";

export function CreditCardStep({active, completed, invoice, onChange}: Readonly<StepProps>) {
	const user = useUser();
	const representedUser = user.represents.find(r => r.id == invoice.onBehalfOfUserId) ?? user;
	const creditCards = useUserCreditCards();

	const userCreditCards = creditCards.filter(cc => cc.user.id == representedUser.id);

	useEffect(() => {
		if (userCreditCards.length == 1) {
			onChange({creditCardNumber: userCreditCards[0].cardNumber});
		}
		else if (userCreditCards.length == 0) {
			onChange({creditCardNumber: undefined});
		}
	}, [representedUser]);

	return (
		<WizardStepCard
			active={active}
			completed={completed}
			title="Kreditkarte"
			activeChildren={
				<CardContent>
					<RadioGroup
						label="Kreditkarte"
						required
						options={userCreditCards.map(cc => cc.cardNumber)}
						value={invoice.creditCardNumber}
						onChange={creditCardNumber => onChange({creditCardNumber})}
						renderLabel={maskCreditCardNumber}
					/>
				</CardContent>
			}
			completedChildren={<CardContent>{maskCreditCardNumber(invoice.creditCardNumber)}</CardContent>}
		/>
	);
}
